export { segment, normalizeEmail, BRAND_NAMES } from './segment';
export { SegmentProvider } from './SegmentProvider';
